import React, { useMemo } from 'react';
import styled from "styled-components";
import { Moment } from "moment";
import { HolidayCalendarMonthView } from "./HolidayCalendarMonthView";
import { HolidayDay } from "../../models/Holidays.model";
import { desktop, tablet } from '@shared/ui/atoms/MediaQueries';
import { CompanyHoliday } from '@features/holidays/services/CompanyHolidayService';
import { CustomLeaveDays, CustomNonWorkingDays, NonWorkingDays } from '@features/holidays/services/HolidayService';

export function YearContainer(props: Props) {
  const {startDate, holidaysBooked, colourOverride, companyHolidays, onCompanyHolidayClick} = props;
  const endDate = useMemo(() => startDate.clone().add(1, 'year').subtract(1, 'day'), [startDate]);
  const customLeaveDays = props?.customLeaveDays ?? [];
  const nonWorkingDays = props?.nonWorkingDays ?? [];
  const customNonWorkingDays = props?.customNonWorkingDays ?? [];

  return (
    <Container>
      <Row>
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone()}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(1, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(2, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(3, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(4, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(5, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(6, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(7, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(8, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(9, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(10, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        <HolidayCalendarMonthView enabledStartDate={startDate}
                                  enabledEndDate={endDate}
                                  onCompanyHolidayClick={onCompanyHolidayClick}
                                  colourOverride={colourOverride}
                                  monthDate={startDate.clone().add(11, 'months')}
                                  holidaysBooked={holidaysBooked}
                                  companyHolidays={companyHolidays}
                                  customLeaveDays={customLeaveDays}
                                  customNonWorkingDays={customNonWorkingDays}
                                  nonWorkingDays={nonWorkingDays} />
        {startDate.date() > 1 && <HolidayCalendarMonthView
          enabledStartDate={startDate}
          enabledEndDate={endDate}
          colourOverride={colourOverride}
          monthDate={startDate.clone().add(12, 'months')}
          holidaysBooked={holidaysBooked}
          companyHolidays={companyHolidays}
          customLeaveDays={customLeaveDays}
          nonWorkingDays={nonWorkingDays}/>}
      </Row>
    </Container>
  )
}

interface Props {
  companyHolidays: CompanyHoliday[];
  holidaysBooked: HolidayDay[];
  colourOverride?: string;
  startDate: Moment;
  nonWorkingDays: NonWorkingDays[];
  customNonWorkingDays: CustomNonWorkingDays[];
  customLeaveDays: CustomLeaveDays[];
  onCompanyHolidayClick?: (ch: CompanyHoliday) => any;
}

const Container = styled.div`
  width: 100%;
`

const Row = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  @media (${tablet}) {
    justify-content: flex-start;
    &>* {
      margin-left: 10%;
    }
  }
  @media (${desktop}) {
    &>* {
      margin-left: 2.5%;
    }
  }
`
